import * as React from "react";
import { useGeolocated } from "react-geolocated";
import { useCallback, useEffect, useState, useRef } from "react";
import Map, {
  Marker,
  NavigationControl,
  FullscreenControl,
  ScaleControl,
  GeolocateControl,
} from "react-map-gl";
import Pin from "./pin";

import axios from "./utils/axios";

import ControlPanel from "./ControlPanel";
import mapboxgl from "mapbox-gl";
import { ThreeCircles } from "react-loader-spinner";

import "./index.css";
import tokenService from "../../services/tokenService";
// @ts-ignore
mapboxgl.workerClass =
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const TOKEN =
  "pk.eyJ1IjoibWFydGVmaWxobyIsImEiOiJja2I4OXp2dTYwMjh0MndvMDBvaDdmNGR2In0.guCPHF3f0gJxvDeQkxqDog"; // Set your mapbox token here

const startLat = -23.113886032592788;
const startLng = -47.05691763568768;

export default function Rastrear() {
  const [isLoading, setIsLoading] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [radius, setRadius] = useState(0.2);
  const [lat, setLat] = useState(startLat);
  const [lng, setLng] = useState(startLng);

  useEffect(() => {
    const setCoordinates = () => {
      if (navigator?.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (location) => {
            if (location && lat === startLat && lng === startLng) {
              setLat(location.coords.latitude);
              setLng(location.coords.longitude);
            }
          },
          null,
          {
            enableHighAccuracy: true,
            timeout: 30000,
          }
        );
      }
    };

    setCoordinates();
  }, [lat, lng]);

  const getlocateControlRef: any = useRef();

  const handleGeolocate = useCallback(() => {
    if (getlocateControlRef.current) {
      getlocateControlRef.current.trigger();
    }
  }, [getlocateControlRef]);

  const { coords } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: true,
      timeout: 6000,
    },
    userDecisionTimeout: 5000,
  });

  const handleRadiusChange = useCallback(
    (event: any, value: any) => {
      setRadius(value);
    },
    [setRadius]
  );

  const getNearbyVehiclesCallback = useCallback(async () => {
    const getNearbyVehicles = async () => {
      setIsLoading(true);

      const token = await tokenService.getTokenAsync();
      try {
        if (lat && lng && radius && lat !== startLat && lng !== startLng) {
          const response = await axios.get(
            `api/v1/Veiculo/PorLocalizacao?Latitude=${lat}&Longitude=${lng}&distancia=${radius}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setVehicles(response.data.dataResult);
          setIsLoading(false);
        }
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    };

    await getNearbyVehicles();
  }, [lat, lng, radius]);

  useEffect(() => {
    getNearbyVehiclesCallback();
  }, [getNearbyVehiclesCallback]);

  const openMonitor = (placa: string) => {
    window.open(
      `https://monitor.mottu.cloud/#/home/monitor/${placa}`,
      "_blank"
    );
  };
  return (
    <div style={{ margin: 0, fontFamily: "Helvetica, Arial, sans-serif" }}>
      {coords && (
        <Map
          initialViewState={{
            latitude: lat,
            longitude: lng,
            zoom: 10,
            bearing: 0,
            pitch: 0,
          }}
          mapStyle="mapbox://styles/mapbox/dark-v9"
          mapboxAccessToken={TOKEN}
          style={{ width: "100vw", height: "100vh" }}
          onLoad={handleGeolocate}
        >
          {vehicles &&
            vehicles.map((vehicle: any) => (
              <Marker
                key={vehicle.veiculoId}
                latitude={vehicle.latitude}
                longitude={vehicle.longitude}
                onClick={() => openMonitor(vehicle.placa)}
              >
                <div>
                  <div style={{ color: "white", textAlign: "center" }}>
                    {vehicle?.placa}
                  </div>
                  <Pin size={15} />
                </div>
              </Marker>
            ))}
          <GeolocateControl
            position="top-left"
            showUserLocation={true}
            fitBoundsOptions={{
              zoom: 21,
            }}
            showUserHeading={false}
            showAccuracyCircle={false}
            trackUserLocation={false}
            positionOptions={{ enableHighAccuracy: true }}
            onGeolocate={(position) => {
              setLat(position.coords.latitude);
              setLng(position.coords.longitude);
            }}
            ref={getlocateControlRef}
          />

          <FullscreenControl position="top-left" />
          <NavigationControl position="top-left" />
          <ScaleControl />
          <div
            style={{
              top: "170px",
              left: "0",
              position: "absolute",
            }}
          >
            <div
              style={{
                borderRadius: "4px",
                backgroundColor: "#fff",
                float: "left",
                margin: "10px 0 0 10px",
                boxShadow: "0 0 0 2px rgba(0 0 0 / 10%)",
              }}
            >
              <button
                style={{
                  width: "29px",
                  height: "29px",
                  display: "block",
                  padding: 0,
                  outline: "none",
                  border: 0,
                  boxSizing: "border-box",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  overflow: "hidden",
                  borderRadius: "0 0 4px 4px",
                }}
                onClick={getNearbyVehiclesCallback}
              >
                <span
                  style={{
                    display: "block",
                    width: "100%",
                    height: "100%",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "50%",
                  }}
                >
                  <img
                    alt="svgImg"
                    src="data:image/svg+xml;base64,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"
                  />
                </span>
              </button>
            </div>
          </div>
        </Map>
      )}
      <ControlPanel value={radius} onChange={handleRadiusChange} />

      {isLoading && (
        <div
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            marginRight: "30px",
            marginBottom: "40px",
            background: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <ThreeCircles
            height="50"
            width="50"
            color="#00B131"
            visible={true}
            ariaLabel="three-circles-rotating"
          />
        </div>
      )}
    </div>
  );
}
